module.exports = __webpack_public_path__ + "img/pg.03a14724.svg";